import React from 'react'
import { TextField, MenuItem } from '@mui/material'
import { useField, useFormikContext } from 'formik'

const SelectWrapper = ({
  name,
  options,
  variant = 'outlined',
  icon_,
  InputProps,
  chip,
  ...otherProps
}) => {
  const { setFieldValue } = useFormikContext()
  const [field, meta] = useField(name)

  const handleChange = event => {
    const { value } = event.target
    setFieldValue(name, value)
  }

  const configSelect = {
    ...field,
    ...otherProps,
    select: true,
    variant,
    onChange: handleChange,
    InputProps: {
      ...InputProps,
      ...icon_,
    },
  }

  if (meta && meta.touched && meta.error) {
    configSelect.error = true
    configSelect.helperText = meta.error
  }

  return (
    <TextField {...configSelect} fullWidth>
      {Object.keys(options).map((item, pos) => {
        return (
          <MenuItem key={pos} value={item}>
            {options[item]}
          </MenuItem>
        )
      })}
    </TextField>
  )
}

export default SelectWrapper
